<template>
    <div v-if="list.length">
        <modal-delete-snack
            @confirm="deleteAllChecks(list)"
            :dragList="list"
            :isDataFields="isDataFields"
            :isOrder="isOrder"
        />

        <div>
            <RecursiveItem
                v-for="(item, index) in list"
                :key="item.id || index"
                :item="item"
                :levelIcons="levelIcons"
                :optionIcons="optionIcons"
                :isMaterials="isMaterials"
                :isOrder="isOrder"
                @collapseOpenned="handleToggle"
                @checksCounter="handleCheckChange"
                @isAllChildrenChecked="isAllChildrenChecked"
                @getEditInfos="
                    (id, level, type, parentId) => getEditInfos(id, level, type, parentId)
                "
            />
        </div>

        <div class="col-12 d-flex justify-content-between col-footer-table pagination-table">
            <div class="d-flex align-items-center mb-0 mt-1 por-pagina">
                <span class="text-nowrap">{{ $t(customText) }}</span>
                <b-form-select
                    v-model="pageSize"
                    :options="['10', '20', '30']"
                    class="mx-1"
                />
            </div>

            <b-pagination
                v-model="pageNumber"
                :total-rows="filter ? filter.totalItems : 0"
                :per-page="pageSize"
                class="mt-1 mb-0"
                align="right"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
            >
                <template #prev-text
                    ><feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                /></template>
                <template #next-text
                    ><feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                /></template>
            </b-pagination>
        </div>

        <div
            v-show="selectedChecks > 0 && device !== 'mobile'"
            class="float-bar"
            id="float-bar"
        >
            <span class="close-caption">
                <span>{{ selectedChecks }}</span>
                <span>{{ $t("DepartmentPage.SelectedItems") }}</span>
            </span>
            <div class="box-btn">
                <button
                    class="btn-cancel btn-snack"
                    @click="clearAllChecks(list)"
                >
                    {{ $t("IntegrationPage.Clean") }}
                </button>
                <button
                    class="btn-delete btn-snack"
                    @click="openDeleteModal"
                >
                    {{ $t("IntegrationPage.delete") }}
                </button>
            </div>
        </div>
    </div>
    <div
        v-else
        class="block-no-results"
    >
        <div class="no-results">
            <SearchIcon />
            <p class="text">{{ $t("NoResultsFound") }}</p>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from "vuex";
    import RecursiveItem from "./RecursiveItem.vue";
    import ModalDeleteSnack from "@core/components/collapse-draggable/ModalDeleteSnack.vue";
    import SearchIcon from "@core/assets/icons/search-icon.svg";
    import { BPagination, BFormSelect } from "bootstrap-vue";

    export default {
        components: { BPagination, BFormSelect, RecursiveItem, ModalDeleteSnack, SearchIcon },
        props: {
            filter: {
                type: Object,
                default: () => ({ textFilter: [], pageNumber: 1, pageSize: 10, totalItems: 0 })
            },
            list: { type: Array, default: () => [] },
            levelIcons: { type: Array, default: () => [] },
            optionIcons: { type: Array, default: () => [] },
            permissions: { type: Array, default: () => [] },
            isMaterials: { type: Boolean, default: false },
            isOrder: { type: Boolean, default: false },
            isDataFields: { type: Boolean, default: false },
            customText: { type: String, default: "message.pagelength" },
            selectedChecks: { type: Number, default: 0 }
        },
        data() {
            return {
                pageSize: 0,
                pageNumber: 10,
                level: 1,
                objToDelete: [],
                device:
                    window.innerWidth > 768
                        ? "desktop"
                        : window.innerWidth > 480 && window.innerWidth <= 768
                          ? "tablet"
                          : "mobile"
            };
        },
        mounted() {
            if (this.filter) {
                this.pageSize = this.filter.pageSize;
                this.pageNumber = this.filter.pageNumber;
            }
        },
        created() {
            window.addEventListener("resize", this.handleResize);
        },
        destroyed() {
            window.removeEventListener("resize", this.handleResize);
        },
        methods: {
            ...mapMutations("departments", ["UPDATE_MODAL_DELETE_SNACK_BAR"]),

            handleResize() {
                this.device =
                    window.innerWidth > 768
                        ? "desktop"
                        : window.innerWidth > 480 && window.innerWidth <= 768
                          ? "tablet"
                          : "mobile";
            },

            handleToggle(item) {
                this.$emit("callDetailsRoute", item.id);
            },

            deleteAllChecks(list) {
                this.objToDelete = [];
                this.getIdsToDelete(list, this.level);
                this.$emit("deleteItems", this.objToDelete);
            },

            getIdsToDelete(list, level) {
                list.forEach((e) => {
                    if (e.checked) {
                        this.objToDelete.push({
                            level: level,
                            id: e.id,
                            type: e.type,
                            parentId: e.parentId || null,
                            defaultRoute: level === 2 ? e.default : null
                        });
                    }
                    if (e.child?.length > 0) {
                        this.getIdsToDelete(e.child, level + 1);
                    }
                });
            },

            handleCheckChange() {
                this.countChecked(this.list);
            },

            countChecked(obj) {
                let count = 0;
                const traverse = (items) => {
                    for (const item of items) {
                        if (item.checked) count++;
                        if (item.child?.length) traverse(item.child);
                    }
                };
                traverse(obj);

                this.$emit("checkedCounter", count);
                return count;
            },

            clearAllChecks(list) {
                const clear = (items) => {
                    items.forEach((item) => {
                        if (item.checked) {
                            this.$set(item, "checked", false);
                        }

                        if (item.child && item.child.length > 0) {
                            clear(item.child);
                        }
                    });
                };

                clear(list);

                this.handleCheckChange();
            },

            getEditInfos(id, level, type, parentId) {
                this.$emit("getEditInfos", id, level, type, parentId);
            },

            isAllChildrenChecked() {
                this.handleCheckChange();
            },

            openDeleteModal() {
                if (
                    (this.permissions.length &&
                        this.permissions.find((e) => e.type === "delete")) ||
                    (!this.isMaterials && !this.isOrder)
                ) {
                    this.UPDATE_MODAL_DELETE_SNACK_BAR(true);
                }
            }
        },
        watch: {
            pageNumber(value) {
                this.$emit("updatePageNumber", value);
            },
            pageSize(value) {
                this.$emit("updatepageSize", value);
            }
        }
    };
</script>

<style lang="scss">
    .pagination-table {
        .custom-select {
            cursor: pointer;
            padding: 4px 34px 4px 8px;
            background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.17975 3.78813L7.05862 0.855236L7.64775 1.44457L4.00127 5.14393L0.352313 1.44451L0.941458 0.855158L3.823 3.7882L4.00141 3.96981L4.17975 3.78813Z' fill='%234C4541' stroke='%234C4541' stroke-width='0.5'/%3E%3C/svg%3E") !important;
            height: auto !important;

            &:focus {
                border-color: #974900;
                background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.17975 3.78813L7.05862 0.855236L7.64775 1.44457L4.00127 5.14393L0.352313 1.44451L0.941458 0.855158L3.823 3.7882L4.00141 3.96981L4.17975 3.78813Z' fill='%23974900' stroke='%23974900' stroke-width='0.5'/%3E%3C/svg%3E") !important;
            }
        }

        &.col-footer-table {
            .por-pagina {
                span {
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 20px;
                    color: #4c4541;
                }
            }
            .custom-select {
                padding: 4px 34px 4px 8px;
                background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.17975 3.78813L7.05862 0.855236L7.64775 1.44457L4.00127 5.14393L0.352313 1.44451L0.941458 0.855158L3.823 3.7882L4.00141 3.96981L4.17975 3.78813Z' fill='%23974900' stroke='%23974900' stroke-width='0.5'/%3E%3C/svg%3E") !important;
            }
        }

        .page-item {
            &.active .page-link {
                background-color: #974900;
            }
            .page-link {
                &:hover {
                    color: #974900;
                }
            }
            &.next-item,
            &.prev-item {
                .page-link {
                    &:hover,
                    &:active {
                        background-color: #974900 !important;
                        color: #fff !important;
                    }
                }
            }
        }
    }
    .float-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 15px;

        background: #ffffff;
        border: 1px solid #cfc4be;
        border-radius: 6px;
        box-shadow:
            0px 3px 5px 0px rgba(0, 0, 0, 0.2),
            0px 1px 18px 0px rgba(0, 0, 0, 0.12),
            0px 6px 10px 0px rgba(0, 0, 0, 0.14);

        position: fixed;
        bottom: 20px;
        z-index: 10;
        font-size: 12px;
        outline: none;
        right: 28px;
        width: 100%;
        max-width: 531px;

        .close-caption {
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #4c4541;
            margin-right: auto;
        }

        .box-btn {
            display: flex;
            gap: 16px;

            .btn-snack {
                box-shadow: none;
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                border-radius: 5px;

                &:hover {
                    box-shadow: none;
                }

                &.btn-cancel {
                    background-color: transparent !important;
                    color: #974900 !important;
                    border: 1px solid #974900 !important;
                    padding: 8px 21px;

                    &:hover {
                        background-color: #ffede2 !important;
                    }

                    &:active {
                        background-color: #ffdbc4 !important;
                    }
                }

                &.btn-delete {
                    border: 1px solid #974900 !important;
                    background-color: #974900 !important;
                    color: #ffff !important;
                    padding: 8px 21px;

                    &:hover {
                        background-color: #9f5714 !important;
                    }

                    &:active {
                        background-color: #a45f1f !important;
                    }
                }
            }
        }
    }

    .block-no-results {
        height: 100%;
        padding: 8px 16px 0;
        .no-results {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 16px;
            border-radius: 6px;
            border: 1px solid #cfc4be;

            svg {
                width: 16px;
                height: 16px;
                fill: #998f8a;
            }

            .text {
                margin: 0;
                color: #998f8a;
                font-size: 16px;
                font-weight: 600;
                line-height: 26px;
            }

            @media (max-width: 480px) {
                svg {
                    width: 12px;
                    height: 12px;
                }
                .text {
                    font-size: 12px;
                    line-height: 16px;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .float-bar {
            right: 0;
            left: 0;
            width: calc(100% - 58px);
            margin: 0 auto;
            gap: 16px !important;
            max-width: unset !important;

            .filtered-orders {
                font-size: 18px;
            }

            .box-btn {
                .btn-clean {
                    height: 46px !important;
                }
            }
        }
    }
    @media (max-width: 768px) {
        .pagination-table {
            flex-direction: column;
        }
    }
</style>
